import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useCurrency } from '../../../../hooks/useCurrency';
import ConfirmButton from '../../../../components/buttons/confirmButton';
import TextInput, { inputType } from '../../../../components/inputs/textInput';

const SplitBillCustom = ({ order, onConfirm }) => {
  const { currencySymbol } = useCurrency();
  const { t } = useTranslation();

  const [amount, setAmount] = useState(0);

  const orderTotal =
    (order.price || {}).leftToPay > 0 ? order.price.leftToPay : (order.price || {}).total || 0;

  return (
    <div>
      <TextInput
        id="custom-amount"
        onChange={setAmount}
        value={amount}
        max={orderTotal}
        type={inputType.price}
        placeholder="0.00"
      />
      <div className="mt-5" />
      <div className="flex flex-row justify-between items-center">
        <p className="font-primaryMedium text-base text-bland">{t('checkout.totalBill')}</p>
        <p className="font-primaryMedium text-base text-bland">
          {orderTotal.toFixed(2)} {currencySymbol}
        </p>
      </div>
      <ConfirmButton
        onClick={() => {
          const parsedAmount = parseFloat(amount);
          onConfirm(Number.isNaN(parsedAmount) ? 0 : parsedAmount);
        }}
        disabled={!amount || amount === '0.'}
      />
    </div>
  );
};

export default SplitBillCustom;
